import {
  fetchKitchenSinkAll as fetchKitchenSinkApi,
  fetchKitchenSinkRows as fetchKitchenSinkRowsApi,
} from 'support/api/VideoApi';
import { HttpClient } from 'support/api/api-types';

export const KITCHEN_SINK = 'KITCHEN_SINK' as const;
export const KITCHEN_SINK_ROWS = 'KITCHEN_SINK_ROWS' as const;

export const fetchKitchenSink = () => ({
  type: KITCHEN_SINK,
  promise: (httpClient: HttpClient) => fetchKitchenSinkApi(httpClient),
});

export const fetchKitchenSinkRows = (rowIds: string[]) => ({
  type: KITCHEN_SINK_ROWS,
  promise: (httpClient: HttpClient) => fetchKitchenSinkRowsApi(httpClient, rowIds),
});
